
import template from './views/wizard.html';
const name = 'wizardStatus';

class WizardStatus {

    constructor($scope, $state, $attrs, $compile, $element) {
        'ngInject';
        
        var ctrl = this;
        ctrl.$onInit = function() {
            $scope.tabStats = ctrl.featureData;
        }

         ctrl.$onChange = function( data ) {
            $scope.tabStats = ctrl.featureData;
        }

        ctrl.$doCheck= function(  ) {
            $scope.tabStats = ctrl.featureData;
        }

        ctrl.selectedWizard = function( feature ) {
             $state.go( feature )

        }

    }
}

export default angular.module(name, [
    ])
    .component(name, {
        template: template,
        transclude: true,     
        controllerAs: 'wizardCtrl',
        bindings: {
            featureData: '<'
        },
        controller: ['$scope',  '$state', '$attrs', '$compile', '$element', WizardStatus]
    })



// WEBPACK FOOTER //
// ./src/app/initial_settings/wizard.js